import { withDataVersion } from '@hakimo-ui/hakimo/util';
import {
  DataVersion,
  LocationAlarmUpdateRequestDTO,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateLocationAlarm(
  alarmId: string,
  options?: {
    onSuccess?: (
      data: null,
      variables: LocationAlarmUpdateRequestDTO | null
    ) => void;
    productType?: 'scan' | 'remote-guarding';
    dataVersion?: DataVersion;
  }
) {
  const {
    onSuccess,
    productType = 'remote-guarding',
    dataVersion,
  } = options ?? {};

  const url = `/v2/orm/location_alarms/update/${alarmId}?product=${productType}`;

  const request = new Request(url, {
    method: 'POST',
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, LocationAlarmUpdateRequestDTO | null>(
    request,
    {
      onSuccessInvalidationKeys: [
        ['locationAlarms'],
        ['locationAlarms', alarmId],
        ['remote-guarding', alarmId],
        ['scan', alarmId],
        ['scan'],
        ['remote-guarding'],
        ['location_alarm_updates', alarmId],
      ],
      onSuccess,
    }
  );
}

export default useUpdateLocationAlarm;
